<template>
  <simple-page header="设备管理" @query="query">
    <template #buttons>
      <el-button type="primary" @click="edit">添加</el-button>
      <el-button type="primary" @click="multiEdit" :disabled="selectedDevices.length < 2">批量修改</el-button>
      <el-button type="danger" @click="multiDel" :disabled="selectedDevices.length < 2">批量删除</el-button>
      <!-- 仅系统管理员、单位管理员可批量配置设备参数（对齐 acc-app） -->
      <el-button type="primary" @click="multiSetting" v-if="canSetting"
                 :disabled="selectedDevices.length < 2">参数批量设置</el-button>
      <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
    </template>
    <template #form>
      <el-form inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compId" @change="query" style="width: 150px"
                       :disabled="queryForm.noComp"></comp-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <area-cascader v-model="areaCodes" @change="areaChange"></area-cascader>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model.trim="queryForm.deviceName" clearable
                    placeholder="请输入设备编码或设备名称"
                    @keyup.enter.native="query"
                    style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="在线">
          <el-radio v-model="queryForm.online" label="" @change="query">全部</el-radio>
          <el-radio v-model="queryForm.online" :label="true" @change="query">在线</el-radio>
          <el-radio v-model="queryForm.online" :label="false" @change="query">离线</el-radio>
        </el-form-item>
      </el-form>
    </template>
    <template #formMore>
      <el-form inline>
        <el-form-item label="设备类型">
          <code-select v-model="queryForm.deviceType" code-type="DEVICE_TYPE" @change="query" style="width: 150px"></code-select>
        </el-form-item>
        <el-form-item label="机房类型">
          <code-select v-model="queryForm.roomType" code-type="ROOM_TYPE" @change="query" style="width: 150px"></code-select>
        </el-form-item>
        <el-form-item label="告警">
          <code-select v-model="queryForm.warningType" code-type="WARNING_TYPE" @change="query"></code-select>
        </el-form-item>
        <el-form-item label="软件版本">
          <el-select v-model="queryForm.sv" clearable filterable placeholder="请选择"
                     @change="query" style="width: 180px">
            <el-option v-for="item in svOptions" :key="item.versionCode"
                       :label="item.versionName ? (item.versionCode + ' ' + item.versionName) : item.versionCode"
                       :value="item.versionCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="queryForm.noComp" :label="true" @change="query">未分配设备</el-checkbox>
        </el-form-item>
      </el-form>
    </template>

    <el-table ref="deviceTable" stripe :data="records" :border="true"
              v-loading="loading"
              row-key="deviceCode"
              @selection-change="handleDeviceSelect"
              @sort-change="handleSortChange">
      <el-table-column type="selection" reserve-selection label="选择" width="40" align="center"></el-table-column>
      <column-index></column-index>
      <el-table-column prop="online" label="在线" align="center" width="50" v-slot="{row}">
          <i v-if="row.online" class="fa fa-chain color-success" title="在线"></i>
          <i v-else class="fa fa-chain-broken color-error" title="离线"></i>
      </el-table-column>
      <el-table-column prop="deviceCode" label="设备编号" width="130" sortable="custom" v-slot="{row}">
          <el-link type="primary" @click="showDevice(row)">{{row.deviceCode}}</el-link>
      </el-table-column>
      <el-table-column prop="deviceName" label="设备名称" min-width="150" sortable="custom"></el-table-column>
      <el-table-column prop="areaName" label="所属地区" align="center" min-width="150"></el-table-column>
      <el-table-column prop="address" label="地址" min-width="150" sortable="custom"></el-table-column>
      <el-table-column prop="inFanCount" label="新风台数" align="center" width="60"></el-table-column>
      <column-code-type code-type="DEVICE_TYPE" prop="deviceType" label="设备类型" align="center" min-width="60"></column-code-type>
      <column-code-type code-type="ROOM_TYPE" prop="roomType" label="机房类型" align="center" min-width="60"></column-code-type>
      <el-table-column prop="compName" label="所属单位" min-width="150"></el-table-column>
      <el-table-column prop="acUnion" label="空调联动" align="center" width="80" v-slot="{row}">
        <span v-if="row.acUnion" class="color-success">联动</span>
        <span v-else class="color-gray">不联动</span>
      </el-table-column>
      <el-table-column prop="kwh" label="外接电表" align="center" width="80"></el-table-column>
      <el-table-column prop="selfKwh" label="新风电量" align="center" width="80"></el-table-column>
      <el-table-column prop="sv" label="软件版本" align="center" min-width="100"></el-table-column>
      <column-valid prop="valid"></column-valid>
      <el-table-column prop="fanRunning" label="新风" align="center" width="60" v-slot="{row}">
        <span v-if="row.fanRunning" class="color-success">运行</span>
        <span v-else class="color-gray">停止</span>
      </el-table-column>
      <el-table-column prop="acRunning" label="空调" align="center" width="60" v-slot="{row}">
        <span v-if="!row.acUnion" class="color-gray">--</span>
        <span v-else-if="row.acRunning" class="color-success">运行</span>
        <span v-else class="color-gray">停止</span>
      </el-table-column>
      <el-table-column prop="warningInfo" label="告警信息" align="center" min-width="150" v-slot="{row}">
        <div
          v-for="(text, idx) in warningTexts(row)"
          :key="'w-' + idx"
          :class="text.indexOf('无纺布') >= 0 ? 'color-warning' : 'color-error'"
        >{{ text }}</div>
      </el-table-column>
      <el-table-column prop="imei" label="IMEI" min-width="100"></el-table-column>
      <el-table-column prop="action" label="操作" width="150" align="center" fixed="right" v-slot="{row}">
          <el-button type="text" icon="fa fa-edit" title="编辑" @click="edit(row)" style="font-size: 16px"></el-button>
          <el-button type="text" icon="fa fa-list" title="运行统计" @click="showDayInfo(row)" style="font-size: 16px"></el-button>
          <el-button type="text" icon="fa fa-upload" title="升级软件" @click="softUpdate(row)"
                     :disabled="!row.online"
                     style="font-size: 16px"></el-button>
          <el-button type="text" icon="fa fa-times-circle color-error" title="删除" @click="del(row.deviceCode)" style="font-size: 16px"></el-button>
      </el-table-column>
    </el-table>
    <div style="display: flex;align-items: center;justify-content: space-between;padding: 10px 0">
      <div>
        已选中
        {{selectedDevices.length}}
        条
      </div>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <map-choose-dialog title="位置查看" :visible.sync="mapVisible"
                       v-if="mapVisible" width="90vw"
                       :lng="device.lng"
                       :lat="device.lat"
                       @close="mapVisible = false"></map-choose-dialog>

    <device-edit-dialog title="设备编辑"
                        :visible.sync="editing"
                        v-if="editing"
                        :device="device"
                        @close="editing=false"
                        @save="onSave"></device-edit-dialog>

    <device-multi-edit-dialog title="设备批量编辑"
                              :visible.sync="multiEditing"
                              v-if="multiEditing"
                              :device="device"
                              @close="multiEditing=false"
                              @save="onSave"></device-multi-edit-dialog>

    <device-setting-dialog :visible="true"
                           :device-code="deviceCodes" v-if="!!deviceCodes && settingVisible && !settingPlc"
                           width="80vw" title="设备参数设置"
                           @close="settingVisible=false"></device-setting-dialog>

    <device-setting-dialog2 :visible="true"
                            :device-code="deviceCodes" v-if="!!deviceCodes && settingVisible && settingPlc"
                            width="80vw" title="设备参数设置(吸尘式)"
                            @close="settingVisible=false"></device-setting-dialog2>

  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import CompSelect from "@/components/base/CompSelect";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import MapChooseDialog from "@/components/base/MapChooseDialog";
import DeviceEditDialog from "@/components/device-view/DeviceEditDialog";
import DeviceMultiEditDialog from "@/components/device-view/DeviceMultiEditDialog";
import CodeSelect from "@/components/base/CodeSelect";
import * as querystring from "querystringify";
import DeviceSettingDialog from "@/components/device-view/DeviceSettingDialog.vue";
import DeviceSettingDialog2 from "@/components/device-view/DeviceSettingDialog2.vue";
import SimplePage from "@/components/page/SimplePage.vue";
import ColumnIndex from "@/components/tableColumns/ColumnIndex.vue";
import ColumnValid from "@/components/tableColumns/ColumnValid.vue";
import ColumnCodeType from "@/components/tableColumns/ColumnCodeType.vue";
import AreaCascader from "@/components/base/AreaCascader.vue";
import SessionStore from "@/utils/SessionStore";
export default {
  name: 'DeviceList',
  components: {
    AreaCascader,
    ColumnCodeType,
    ColumnValid,
    ColumnIndex,
    SimplePage,
    DeviceSettingDialog2,
    DeviceSettingDialog,
    CodeSelect,
    DeviceMultiEditDialog, DeviceEditDialog, MapChooseDialog, TablePagination, CompSelect, TitleBar},
  extends: BaseVue,
  data() {
    return {
      mapVisible: false,
      editing: false,
      multiEditing: false,
      settingVisible: false,
      settingPlc: false,
      // 是否可配置设备参数：系统管理员或单位管理员
      canSetting: false,
      selectedDevices: [],
      deviceCodes: "",
      user: {},
      areaCodes: [],
      svOptions: [],
      queryForm: {
        noComp: false,
        compId: '',
        deviceName: '',
        online: '',
        warningType: '',
        sv: '',
        page: 1,
        limit: 10,
        //排序
        sortBy: null,
        sortType: null
      },
      total: 0,
      records: [],
      device: null,
      warningNameMap: {}
    }
  },
  created() {
    //重置缓存
    this.queryForm = this.getComponentCache() || this.queryForm;
    this.loadSvOptions();
    this.getCodes("WARNING_TYPE").then(dr => {
      const map = {};
      (dr.rows || []).forEach(item => {
        if (item.codeValue) {
          map[item.codeValue] = item.codeText;
        }
      });
      this.warningNameMap = map;
    });
    this.user = SessionStore.getUser();
    // 与移动端一致：非管理员不展示参数批量设置入口
    this.canSetting = SessionStore.canSettingDeviceParams();
    if(!this.user.superAdmin && !this.user.roles.find(r=>r.roleCode === "super_admin")) {
      if(this.user.company.provCode) {
        this.areaCodes.push(this.user.company.provCode);
        if(this.user.company.cityCode) {
          this.areaCodes.push(this.user.company.cityCode);
        }
      }
    }
    this.loadData();
  },
  methods: {
    warningTexts(row) {
      const texts = [];
      const codes = (row.warningTypeCodes || "")
        .split(",")
        .map(s => (s || "").trim())
        .filter(Boolean);
      codes.forEach(code => {
        texts.push(this.warningNameMap[code] || code);
      });
      return texts;
    },
    /**
     * 重新查询：重置到第一页，并清空表格跨页选中状态。
     * 分页切换走 loadData，会保留 reserve-selection 的选中项。
     */
    query(){
      this.queryForm.page = 1;
      // 条件变更时清空所有已选条目，避免筛选后仍残留旧选中
      this.clearDeviceSelection();
      this.loadData();
    },
    /**
     * 清空设备表格选中状态（含 reserve-selection 缓存）
     */
    clearDeviceSelection() {
      this.selectedDevices = [];
      if (this.$refs.deviceTable) {
        this.$refs.deviceTable.clearSelection();
      }
    },
    loadData() {
      this.loading = true;
      this.postForm("/device/v2/getDeviceList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    showMap(row){
      this.device = row;
      this.mapVisible = true
    },
    //详情页
    showDevice(device) {
      this.saveCache();
      this.$router.push({
        path: "/deviceView",
        query: {
          deviceCode: device.deviceCode
        }
      });
    },

    edit(row) {
      this.device = Object.assign({
        valid: true,
        deviceType: '1',
        inFanCount: 1,
        outFanCount: 1,
        acCount: 1
      }, row || {});
      this.editing = true;
    },
    multiEdit() {
      if(this.selectedDevices.length === 0) {
        this.$message.info("请选择你要批量修改的设备");
        return;
      }
      let first = this.selectedDevices[0];
      if(this.selectedDevices.length === 1) {
        this.edit(first);
        return;
      }
      this.device = {
        compId: first.compId,
        provCode: first.provCode,
        cityCode: first.cityCode,
        townCode: first.townCode,
        inFanCount: first.inFanCount,
        outFanCount: first.outFanCount,
        acCount: first.acCount,
        acPower: first.acPower,
        valid: true
      }
      let deviceCodes = [];
      this.selectedDevices.forEach(d => {
        deviceCodes.push(d.deviceCode);
      });
      this.device.deviceCode = deviceCodes.join(",");
      this.multiEditing = true;
    },
    onSave(){
      this.editing = false;
      this.query();
    },
    del(deviceCode) {
      this.$confirm("确定要删除“"+deviceCode+"”这些设备吗？","系统提示").then(()=>{
        this.loading = true;
        this.postForm("/device/deleteDevice", {
          deviceCode: deviceCode
        },true).then(()=>{
          this.loadData();
        }).finally(()=>{
          this.loading = false;
        })
      });
    },
    multiDel() {
      let deviceCodes = [];
      this.selectedDevices.forEach(record=>{
        deviceCodes.push(record.deviceCode);
      });
      if(!deviceCodes.length) {
        this.$message.warning("请勾选你要删除的设备");
        return;
      }
      this.del(deviceCodes.join(","));
    },
    loadSvOptions() {
      this.postForm("/hw-protocol/listOptions", {}, true).then(dr => {
        this.svOptions = dr.rows || [];
      });
    },
    /**
     * 批量打开设备参数设置；仅系统管理员、单位管理员可操作
     */
    multiSetting() {
      // 双重校验，防止入口被绕过后仍发起设置
      if (!this.canSetting) {
        this.$message.warning("仅系统管理员或单位管理员可配置设备参数");
        return;
      }
      let deviceCodes = [];
      this.selectedDevices.forEach(record=>{
        deviceCodes.push(record.deviceCode);
      });
      if(!deviceCodes.length) {
        this.$message.info("请勾选你要批量设置参数的设备");
        return;
      }
      const svList = this.selectedDevices.map(d => (d.sv || "").trim());
      const firstSv = svList[0];
      if(!firstSv) {
        this.$message.warning("所选设备软件版本未知，无法批量设置参数");
        return;
      }
      if(svList.some(sv => sv !== firstSv)) {
        this.$message.warning("请选择同一软件版本的设备进行参数批量设置");
        return;
      }
      const typeList = this.selectedDevices.map(d => d.deviceType || "");
      const firstType = typeList[0];
      if(typeList.some(t => t !== firstType)) {
        this.$message.warning("请选择同一设备类型的设备进行参数批量设置");
        return;
      }
      this.deviceCodes = deviceCodes.join(",");
      this.settingPlc = firstType === "3";
      this.settingVisible = true;
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/device/export?"+params);
    },
    handleDeviceSelect(data) {
      this.selectedDevices = data;
    },
    handleSortChange({column, prop, order}) {
      if(order == null) {
        this.queryForm.sortBy = null;
        this.queryForm.sortType = null;
      } else {
        this.queryForm.sortBy = prop;
        this.queryForm.sortType = (order === "ascending" ? "asc" : "desc")
      }
      this.query();
    },
    showDayInfo(row) {
      this.saveCache();
      this.$router.push({
        path: "/deviceDayInfo",
        query: {
          deviceCode: row.deviceCode
        }
      })
    },
    softUpdate(row) {
      this.saveCache();
      this.$router.push({
        path: "/deviceUpdate",
        query: {
          deviceCode: row.deviceCode
        }
      })
    },
    saveCache() {
      this.setComponentCache(this.queryForm);
    },
    areaChange(){
      if(this.areaCodes.length > 0) {
        this.queryForm.provCode = this.areaCodes[0];
        this.queryForm.cityCode = this.areaCodes[1];
        this.queryForm.townCode = this.areaCodes[2];
      } else {
        this.queryForm.provCode = null;
        this.queryForm.cityCode = null;
        this.queryForm.townCode = null;
      }
      this.query();
    }
  }
}
</script>

<style scoped>

</style>